import Loading from '../../../Common/Loading';
import { FamiliesPerIndigenousGroup } from './FamiliesPerIndigenousGroup';
import { FamiliesPerIndigenousReservation } from './FamiliesPerIndigenousReservation';
import { FamiliesPerQuilombolaComunity } from './FamiliesPerQuilombolaComunity';
import { Indicators } from './Indicators';
import { IndigenousFamily } from './IndigenousFamily';
import { IndigenousReservation } from './IndigenousReservation';
import { QuilombolaFamily } from './QuilombolaFamily';
import { TradicionalGroupsIndicator } from './TradicionalGroupsIndicator';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const Charts = () => {
    const { isLoading } = useTradicionalGroupsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="w-100">
                <TradicionalGroupsIndicator />
            </div>
            <div className="charts-side-by-side-dashboards">
                <IndigenousFamily />
                <FamiliesPerIndigenousGroup />
            </div>
            <div className="charts-side-by-side-dashboards">
                <IndigenousReservation />
                <FamiliesPerIndigenousReservation />
            </div>
            <div className="charts-side-by-side-dashboards">
                <QuilombolaFamily />
                <FamiliesPerQuilombolaComunity />
            </div>
        </>
    );
};
